{
    "webshop_offer_voucher_correctCode": "올바른 코드가 입력됨",
    "webShop_howToFindId_desc": "플레이어 프로필에서 개인 ID를 확인하고 복사할 수 있습니다.",
    "webShop_howToFindId_link": "개인 ID를 어디서 찾을 수 있나요?",
    "webshop_offer_voucher_codeIsIncorrect": "코드가 잘못됨",
    "webshop_offer_voucher_enterYourCode": "개인 ID 입력",
    "webShop_unexpectedError_desc": "예기치 못한 오류 발생, 나중에 다시 시도하세요.",
    "webShop_accountBanned_desc": "계정이 정지됨!",
    "webshop_confirm": "확인",
    "webshop_termsConditions_1": "약관",
    "webshop_purchase_privacyPolicy": "개인정보취급방침",
    "webshop_legal_1": "법률",
    "webshop_support_1": "지원",
    "mbs_access_welcome_desc": "환영합니다, {0} 님",
    "btn_login": "로그인",
    "mbs_access_error_sessionExpired_desc": "세션이 만료되었습니다. 계정 ID를 직접 입력해 주십시오."
}
